import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'propensityComponentOpacity' })
export class PropensityComponentOpacityPipe implements PipeTransform {
  transform(inputWeighting) {
    return Math.max(1.5, Math.abs(inputWeighting)) / 5;
  }
}
